<template>
  <div class="c-partner-mapping-tab__partner-cell">
    <BittsAvatar
      :org="partner"
      :show-initials="true"
      size="small"
      shape="square"
    />
    <span class="c-partner-mapping-tab__partner-name">
      {{ params.data.partner_name }}
    </span>
    <OfflineManagedPartnerLabel
      v-if="partner && (partner.offline_partner || partner.virtual_partner)"
      :partner="partner"
      :is-tag="false"
      :show-icon="true"
      placement="right"
    />
  </div>
</template>

<script setup lang="ts">
import { BittsAvatar } from '@crossbeam/bitts';

import { ICellRendererParams } from '@ag-grid-community/core';
import { computed } from 'vue';

import OfflineManagedPartnerLabel from '@/components/partners/OfflineManagedPartnerLabel.vue';

import { usePartnersStore } from '@/stores';

const { params } = defineProps<{ params: ICellRendererParams }>();

const partnersStore = usePartnersStore();
const partner = computed(() =>
  partnersStore.getPartnerOrgByUuid(params.data.partner_org_uuid),
);
</script>
<style lang="pcss">
@reference "../../../../../css/theme.css";
.c-partner-mapping-tab__partner-cell {
  @apply flex items-center gap-10;
}

.c-partner-mapping-tab__partner-name {
  @apply text-neutral-900 text-base font-normal;
}
</style>
